import { createContext, useContext } from 'react';

import { EnvironmentNameType } from '../types/enums/envnametype.enum';

import type { UserProfilePublic } from '../user/userTypes';

interface OpenSectionsContextType {
    openSections: string[];
    toggleSection: (sectionName: string) => void;
}

export const OpenSectionsContext = createContext<
    OpenSectionsContextType | undefined
>(undefined);

interface CurrentEnvironmentContextType {
    currentEnvName: EnvironmentNameType;
}

export const CurrentEnvironmentContext = createContext<
    CurrentEnvironmentContextType | undefined
>(undefined);
export const UserContext = createContext<UserProfilePublic | null>(null);
export const useUser = () => useContext(UserContext);
